// @flow
import { Record, List } from "immutable"

import MultiPlace from "./MultiPlace"
import { createAnytime, createTimeToStay } from "./SearchDate/utils"
import type { DateRange, Anytime, TimeToStay } from "./SearchDate/SearchDate"
import type { Plain } from "./SearchPlace"
import SearchPlace from "./SearchPlace"

const SalesmanFormDataRecord = Record({
  dateRangeEnabled: true,
  timeOfStayEnabled: true,
  dateRange: createAnytime(true),
  timeOfStay: createTimeToStay(3, 5, true),
  destination: new MultiPlace({
    places: List([new SearchPlace({ mode: "anywhere", isDefault: true })]),
  }),
})

export default class SalesmanFormData extends SalesmanFormDataRecord {
  dateRange: DateRange | Anytime

  timeOfStay: TimeToStay

  destination: MultiPlace

  dateRangeEnabled: boolean

  timeOfStayEnabled: boolean

  static fromPlainJS(plain: Plain): SalesmanFormData {
    return new SalesmanFormData({
      ...plain,
      // $FlowFixMe
      destination: MultiPlace.fromPlainJS(plain.destination),
      // $FlowFixMe
      dateRange: plain.dateRange,
    })
  }
}
